import React from 'react'
import BlogPost from '../../components/BlogPost'
import Reply from '../../components/Reply'
import Related from '../../components/Related'
import { Container, Wrapper } from './style'


export default function BlogPostPage() {
    return (
        <Container>
            <Wrapper>
                <BlogPost />
                <Reply />
                <Related />
            </Wrapper>
        </Container>
    )
}
